module.exports = __webpack_public_path__ + "img/cpi-test-only.b9a66977.svg";